import React from 'react';
import { PdfHuchaCardContainer } from '../../../ui/pdf-hucha-card-container';
import { PdfHuchaRenovadoresCardC2 } from './pdf-hucha-renovadores-card-c2';
import { PdfHuchaRenovadoresCardC3 } from './pdf-hucha-renovadores-card-c3';

export const PdfHuchaRenovadoresCard: React.FC<{
	dineroHucha: string;
	DGTLabelInfo?: boolean;
}> = ({ dineroHucha, DGTLabelInfo }) => {
	DGTLabelInfo = DGTLabelInfo ?? false;
	return (
		<PdfHuchaCardContainer>
			<PdfHuchaRenovadoresCardC2 dineroHucha={dineroHucha} />
			<PdfHuchaRenovadoresCardC3 DGTLabelInfo={DGTLabelInfo} />
		</PdfHuchaCardContainer>
	);
};
